interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPageList(current: number, total: number): (number | "ellipsis")[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  const pages: (number | "ellipsis")[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("ellipsis");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("ellipsis");
  pages.push(total);
  return pages;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPageList(currentPage, totalPages);

  const baseBtn =
    "inline-flex items-center justify-center min-w-9 h-9 px-3 rounded-md text-sm font-label transition-colors whitespace-nowrap cursor-pointer";

  return (
    <nav className="flex items-center justify-center gap-1.5 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        className={`${baseBtn} ${
          currentPage === 1
            ? "text-foreground-300 cursor-not-allowed"
            : "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
        }`}
        disabled={currentPage === 1}
        onClick={() => onChange(currentPage - 1)}
      >
        <i className="ri-arrow-left-s-line" />
        <span className="hidden sm:inline ml-0.5">上一页</span>
      </button>

      {pages.map((page, index) =>
        page === "ellipsis" ? (
          <span
            key={`ellipsis-${index}`}
            className="inline-flex items-center justify-center w-9 h-9 text-foreground-400"
          >
            …
          </span>
        ) : (
          <button
            key={page}
            type="button"
            className={`${baseBtn} ${
              page === currentPage
                ? "bg-primary-600 text-white"
                : "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
            }`}
            onClick={() => onChange(page)}
          >
            {page}
          </button>
        )
      )}

      <button
        type="button"
        className={`${baseBtn} ${
          currentPage === totalPages
            ? "text-foreground-300 cursor-not-allowed"
            : "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
        }`}
        disabled={currentPage === totalPages}
        onClick={() => onChange(currentPage + 1)}
      >
        <span className="hidden sm:inline mr-0.5">下一页</span>
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}